import { render, staticRenderFns } from "./HtmlEditor.vue?vue&type=template&id=2b338230&scoped=true&"
import script from "./HtmlEditor.vue?vue&type=script&lang=ts&"
export * from "./HtmlEditor.vue?vue&type=script&lang=ts&"
import style0 from "./HtmlEditor.vue?vue&type=style&index=0&id=2b338230&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b338230",
  null
  
)

export default component.exports